<template>
    <div class="container pb-4 mb-4">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row pb-2">
  <div class="col"><h5>Visitors</h5></div>
</div>

<b-card no-body>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="People" title-link-class="darklink">
          <b-card-text><admin-visitors-list :status="1"></admin-visitors-list></b-card-text>
        </b-tab>
        <b-tab title="ZA" title-link-class="darklink">
          <b-card-text><admin-visitors-list :status="2"></admin-visitors-list></b-card-text>
        </b-tab>
        <b-tab title="ZW" title-link-class="darklink">
          <b-card-text><admin-visitors-list :status="3"></admin-visitors-list></b-card-text>
        </b-tab>
        <b-tab title="Bots" title-link-class="darklink">
          <b-card-text><admin-visitors-list :status="4"></admin-visitors-list></b-card-text>
        </b-tab>
        <b-tab title="Other" title-link-class="darklink">
          <b-card-text><admin-visitors-list :status="5"></admin-visitors-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

      </div>
    </div>
  </div>
</template> 

<script>
export default {

  data() {
    return {
      tabIndex: 0,
      creating: false,
    };
  },

}
</script>

<style scoped>
td:hover {cursor: pointer;}
.application_image { width: 100%; border-radius: 0.25rem; }
</style>